import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'

export class DeleteParentActionStore {
  constructor(private onDelete: () => void) {
    this._openModal()
  }
  modalId = nanoid()
  public _openModal() {
    modalStore.addModal({
      id: this.modalId,
      type: ModalTypeList.ALERT,
      title: 'Delete action?',
      desc: 'This will also remove all actions that follow it.',
      primaryAction: {
        text: 'Yes, delete',
        onAction: () => {
          this.onDelete()
          this.onClose()
        },
      },
      closeActionButtonProps: {
        title: 'Cancel',
        contained: 'secondary',
      },
    })
  }

  onClose = () => {
    modalStore.closeModal(this.modalId)
  }
}
